export enum DataRetentionTypeEntity {
  CONVERSATION = "CONVERSATION",
  TRANSCRIPT = "TRANSCRIPT",
}

export interface RetentionPeriod {
  label: string;
  value: string;
}

export interface DataRetentionSettingEntity {
  id: string;
  firmId: string;
  entityType: DataRetentionTypeEntity;
  retentionPeriod: number;
  createdAt: number;
  updatedAt: number;
  updatedBy: string;
}
